import React from 'react'
import { SVGProps } from 'react'

const PlusIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={12}
    height={12}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M5.46014 10.5V2.5H6.53986V10.5H5.46014ZM2 7.03713V5.96288H10V7.03713H2Z" />
  </svg>
)
export default PlusIcon
